import isArray from 'lodash/isArray'
import type { FormAcceptedValues, ValueBase } from 'types'

export function getValue<T = FormAcceptedValues>(
  value?: ValueBase<T> | Array<ValueBase>,
): undefined | ValueBase<T> {
  if (typeof value !== 'undefined' && !isArray(value)) return value
  return undefined
}
